<section class="throttling-section">
  <div class="throttling-desc">
    Please note this item has an estimated wait time of <br> <strong>{{cartProduct.throttlingEstimation}}</strong>. Accept to add to cart.
  </div>
  <div class="throttling-butn-action">
    <button class="footer-button cancel-btn" (click)="dialogRef.close(false)">Go Back to menu item</button>
    <button class="footer-button" (click)="dialogRef.close(true)">Accept</button>
  </div>
</section>
